import protoRoot from "../proto-root";
import LullabyPlayerSettings from "./LullabyPlayerSettings";

function create({ isPlaying, currentTime, settings }) {
  const LullabyPlayerState = protoRoot.lookupType(`comm.LullabyPlayerState`);

  return LullabyPlayerState.create({
    isPlaying,
    currentTime,
    settings: LullabyPlayerSettings.create(settings)
  });
}

export default {
  create
};

// message LullabyPlayerState {
//   bool isPlaying = 1;
//   int64 currentTime = 2;
//   LullabyPlayerSettings settings = 3;
// }
